import { render, staticRenderFns } from "./GatePass.vue?vue&type=template&id=57cc06c3&scoped=true"
import script from "./GatePass.vue?vue&type=script&lang=js"
export * from "./GatePass.vue?vue&type=script&lang=js"
import style0 from "./GatePass.vue?vue&type=style&index=0&id=57cc06c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cc06c3",
  null
  
)

export default component.exports